import $ from '../$';
import './each';
import { parse } from './utils/event';
$.fn.trigger = function (type, extraParameters) {
  const event = parse(type);
  let eventObject;
  const eventParams = {
    bubbles: true,
    cancelable: true
  };
  const isMouseEvent = ['click', 'mousedown', 'mouseup', 'mousemove'].indexOf(event.type) > -1;
  if (isMouseEvent) {
    // Note: MouseEvent 无法传入 detail 参数
    eventObject = new MouseEvent(event.type, eventParams);
  } else {
    eventParams.detail = extraParameters;
    eventObject = new CustomEvent(event.type, eventParams);
  }
  // @ts-ignore
  eventObject._detail = extraParameters;
  // @ts-ignore
  eventObject._ns = event.ns;
  return this.each(function () {
    this.dispatchEvent(eventObject);
  });
};